<div class="modal-dialog modal-xl mt-0 mb-0" role="document">
    <div class="modal-content" style="min-height: 450px;">
        <div class="modal-body padding">
            <button type="button" class="btn-close float-end" data-bs-dismiss="modal"
                (click)="refModal.hide()"></button>
            <div class="col-lg-12 col-md-12 col-sm-12 mb-4">
                <h4 class="titulo_seccao">Painel de chamados</h4>
            </div>
            <div class="container">
                <div class="row text-start px-3">
                </div>
                <form [formGroup]="resourceFormSearch">
                    <div class="row justify-content-center pb-2">
                        <div class="card col-10 mb-3">
                            <div class="row mt-1">
                                <div class="col-6">
                                    <app-select-field [itens]="ListaTiposTickets" aria-label="Tipo Ticket"
                                        label="Tipo Ticket" formControlName="tipoTicket"></app-select-field>
                                </div>
                                <div class="col-6">
                                    <app-input-field formControlName="empresa" label="Empresa"
                                        aria-label="Empresa"></app-input-field>
                                </div>
                            </div>

                            <div class="row {{campoPecaAtiva == 1?'active':'none'}}">
                                <div class="col-6">
                                    <app-input-field formControlName="peca" label="Peça"
                                        aria-label="Peça"></app-input-field>
                                </div>
                            </div>



                            <div class="row">
                                <div class="col-6">
                                    <app-input-field formControlName="protocolo" label="Protocolo"
                                        aria-label="Protocolo"></app-input-field>
                                </div>
                                <div class="col-6">
                                    <app-input-field formControlName="veiculo" label="Veiculo"
                                        aria-label="Veiculo"></app-input-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-4">
                                    <app-input-field formControlName="placa" label="Placa"
                                        aria-label="Placa"></app-input-field>
                                </div>
                                <div class="col-8 mb-3">Anexo<label for="anexo"></label>
                                    <input type="file" aria-label="Solicitação"
                                            label="Solicitação" class="form-control d-none mr-1 mt-2" id="anexo" multiple #fotos
                                        style="display:block !important;">
                                </div>
                            </div>

                            <div class="row">
                                <div class="{{statusFunc == 2 ? 'active':'none'}} col-6">
                                    <app-select-field [itens]="statusTicket" aria-label="Status Ticket"
                                        label="Status Ticket" formControlName="status"></app-select-field>
                                </div>
                            </div>

                            <hr>
                            <footer>
                                <div class="row">
                                    <div class="col-12">
                                        <app-input-field-text-area formControlName="solicitacao" aria-label="Solicitação"
                                            label="Solicitação"></app-input-field-text-area>
                                    </div>
                                </div>
    
                                <div class="row justify-content-end mb-3">
                                    <div class="{{statusFunc == 0 ? 'active':'none'}} col-4 text-end">
                                        <button class="btn btn-primary" (click)="enviar()"> Enviar</button>
                                        
                                    </div>
                                    <div class="{{statusFunc == 2 ? 'active':'none'}} col-4 text-end">
                                        <button class="btn btn-primary" (click)="editar()"> Editar</button>
                                    </div>
                                </div>
                            </footer>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>